import 'cross-fetch/polyfill';
import fetch from 'cross-fetch';
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

export const client = new ApolloClient({
  link: new HttpLink({ uri: 'https://graphql.contentful.com/content/v1/spaces/trxnyx7103jg/environments/master/', fetch, headers: { authorization: "Bearer hKoGSpEFNeFxwqAs9a03kVa3PDhW50SIHtdP-jczbhM" } }),
  cache: new InMemoryCache()
});